import { EncryptedObjectIdString, ObjectIdString } from '../types/common';
import { SiteDto } from '../types/dto/site';
import {
    ApiClient,
    buildSimpleFormPath,
    createResourceService,
} from './resourceService';

export const getSites = createResourceService<
    {
        encryptedSimpleFormId: EncryptedObjectIdString;
        projectId: ObjectIdString;
    },
    SiteDto[]
>({
    getPath: ({ encryptedSimpleFormId, projectId }) =>
        buildSimpleFormPath(
            encryptedSimpleFormId,
            'project',
            projectId,
            'site',
        ),
    client: ApiClient.Unauthorized,
});
